import React, { useEffect, useRef, useState } from 'react';

interface AmountInputProps {
  onChange?: (value: string) => void;
}

export const AmountInput = ({ onChange }: AmountInputProps) => {
  const [rawValue, setRawValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const formatAmount = (value: string) => {
    if (!value) return '0.00';

    const numericValue = parseInt(value, 10) || 0;

    return (numericValue / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;
    value = value.replace(/\D/g, ''); // Elimina caracteres no numéricos
    if (value.length > 1 && value.startsWith('0')) {
      value = value.replace(/^0+/, ''); // Evita ceros a la izquierda
    }

    setRawValue(value);
    if (onChange) {
      onChange(formatAmount(value));
    }
  };

  return (
    <label className="block w-full">
      <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
        Monto
      </span>
      <div
        className={`w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 `}
      >
        <input
          type="text"
          value={formatAmount(rawValue)}
          onChange={handleChange}
          ref={inputRef}
          style={{ textAlign: 'right' }}
          placeholder="0.00"
          name="PM_AMOUNT"
          className="focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 text-text-black tracking-wider p-0 "
        />
      </div>
    </label>
  );
};
